const Shot = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.875 5.625C10.8395 5.625 10 6.46447 10 7.5C10 8.53553 10.8395 9.375 11.875 9.375C12.9105 9.375 13.75 8.53553 13.75 7.5C13.75 6.46447 12.9105 5.625 11.875 5.625Z"
      fill="#DF7009"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 4.79167C2.5 3.52601 3.52601 2.5 4.79167 2.5H15.2083C16.474 2.5 17.5 3.52601 17.5 4.79167V15.2083C17.5 16.474 16.474 17.5 15.2083 17.5H4.79167C3.52601 17.5 2.5 16.474 2.5 15.2083V4.79167ZM16.2397 15.3556L12.4032 11.5191C11.9964 11.1123 11.3369 11.1123 10.9301 11.5191L10.1473 12.3019C10.066 12.3833 9.93405 12.3833 9.85269 12.3019L7.39444 9.84367C6.99633 9.44556 6.35394 9.43583 5.94395 9.8217L3.75 11.8866V4.79167C3.75 4.21637 4.21637 3.75 4.79167 3.75H15.2083C15.7836 3.75 16.25 4.21637 16.25 4.79167V15.2083C16.25 15.2583 16.2465 15.3075 16.2397 15.3556Z"
      fill="#DF7009"
    />
  </svg>
)

export default Shot
